<template>
    <div :class="[sectionClass]" :ref="blockId" :style="{height: sectionHeight}">
        <div :class="[parallax ? parallaxClass : '', fixed ? fixedClass : '', containerClass]" :ref="uid">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { WithBreakpointComponent } from './breakpoints';
export default {
    mixins: [WithBreakpointComponent],
    props: {
        uid: {default: 'parallax', type: String},
        parallax: {default: true, type: Boolean},
        speedFactor: {default: 0.15, type: Number},
        fixed: {default: false, type: Boolean},
        breakpoint: {default: '(min-width: 0px)', type: String},
        sectionClass: {default: 'parallax', type: String},
        sectionHeight: {default: '100%', type: String},
        containerClass: {default: 'parallax__image', type: String},
        parallaxClass: {default: 'is-parallax', type: String},
        fixedClass: {default: 'is-fixed', type: String},
        direction: {default: 'up', type: String}
    },
    data: () => ({
        el: null
    }),
    computed: {
        directionValue() {
            return this.direction === 'down' ? +1 : -1;
        },
        blockId() {
            return this.uid + 'block';
        }
    },
    watch: {
        currentBreakpoint(val, oldVal) {
            if (val === 'phone' || oldVal === 'phone') {
                this.setupListener();
            }
        }
    },
    mounted() {
        if (this.parallax && !this.fixed) {
            this.el = this.$refs[this.uid];
            window.requestAnimationFrame = window.requestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                function(f) {
                    setTimeout(f, 1000 / 60);
                };
            this.setupListener();
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scrollHandler, false);
    },
    methods: {
        animateElement() {
            const headerHeight = (this.currentBreakpoint === 'phone')
                        ? 80 // Mobile header height
                        : (this.currentBreakpoint === 'tablet')
                            ? 100 // Tablet header height
                            : 126; // Greater than tablet header height
            const parentHeight = this.$refs[this.blockId].offsetHeight;
            const parallaxHeight = this.$refs[this.uid].offsetHeight;
            const availableOffset = parallaxHeight - parentHeight;
            const offset = window.pageYOffset - $(this.$refs[this.blockId]).offset().top + headerHeight;
            //let animationValue = window.pageYOffset * this.speedFactor;
            let animationValue = offset * this.speedFactor;
            
            if (animationValue <= availableOffset && animationValue >= 0) {
                this.el.style.transform = `translate3d(0, ${animationValue * this.directionValue}px, 0)`;
            }
        }, 

        scrollHandler() {
            window.requestAnimationFrame(() => {
                if (this.isInView(this.$refs[this.blockId])) {
                    this.animateElement();
                }
            });
        },

        isInView(el) {
            const rect = el.getBoundingClientRect();
            const wHeight = (window.innerHeight || document.documentElement.clientHeight);
            return rect.bottom >= 0 &&
                   rect.top <= wHeight;
        },

        setupListener() {
            if (this.currentBreakpoint === 'phone') {
                window.removeEventListener('scroll', this.scrollHandler, false);
            } else {
                window.addEventListener('scroll', this.scrollHandler, false);
            }
        }
    }
}
</script>
